
const forms = {
  getFormData(form) {
    return Object.values(form).reduce((obj, field) => {
      if (
        field.getAttribute("type") == "radio" ||
        field.getAttribute("type") == "checkbox"
      ) {
        if (field.checked) {
          obj[field.name] = field.value;
        }
      } else {
        obj[field.name] = field.value;
      }
      return obj;
    }, {});
  },

  formMessage(className) {
    let newsletter = document.querySelector(".newsletter__form");
	newsletter.classList.remove('success');
	newsletter.classList.remove('fail');
	
	newsletter.classList.add(className);
  },

  reset() {
    let newsletter = document.querySelector(".js-newsletter__form");
	newsletter.reset();
  },

  sendData(item) {
    var data = new FormData();

    for (var key in item) {
      data.append(key, item[key]);
    }

    fetch(ajax, {
      method: "POST",
      body: data,
    }).then((res) => {
      res.text().then((value) => {
        if (value == "success") {
		  forms.formMessage(value);
		  forms.reset();
        } else {
			forms.formMessage(value);
		}
      });
    });
  },

  handleForms: () => {
    let newsletter = document.querySelector(".js-newsletter__form");
    newsletter.addEventListener("submit", function (e) {
      e.preventDefault();
      forms.sendData(forms.getFormData(newsletter));
    });
  },
};

export default forms;
